import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";

const updateGetOrganizationsCache = ({
  trainingValidities,
  isDelete = false,
}) => {
  try {
    if (trainingValidities.length) {
      const cacheKey = {
        query: require("../api/query/getOrganizations.gql"),
        variables: { limit: 0, skip: 0, filterInput: null },
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getOrganizations) {
        const existingOrgIndex =
          cachedData.getOrganizations.organizations.findIndex(
            x => x._id === trainingValidities[0].organization._id
          );

        if (existingOrgIndex >= 0) {
          const existingOrganization =
            cachedData.getOrganizations.organizations[existingOrgIndex];

          for (const doc of trainingValidities) {
            const existingIndex =
              existingOrganization.trainingValidities.findIndex(
                x => x._id === doc._id
              );

            if (existingIndex >= 0) {
              if (isDelete) {
                cachedData.getOrganizations.organizations[
                  existingOrgIndex
                ].trainingValidities.splice(existingIndex, 1);
              } else {
                cachedData.getOrganizations.organizations[
                  existingOrgIndex
                ].trainingValidities[existingIndex] = doc;
              }
            } else {
              cachedData.getOrganizations.organizations[
                existingOrgIndex
              ].trainingValidities.unshift(doc);
            }
          }

          apolloClient.writeQuery({ ...cacheKey, data: cachedData });
        }
      }
    }
  } catch (e) {
    console.log(
      "createOrUpdateOrDeleteTrainingValidity.updateGetOrganizationsCache:exception:",
      e.message
    );
  }
};

export const createOrUpdateTrainingValidities = inputs => {
  const mutation = require("../api/mutation/createOrUpdateTrainingValidities.gql");
  const variables = { inputs };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetOrganizationsCache({
        trainingValidities: data.createOrUpdateTrainingValidities,
      });

      return { data: data.createOrUpdateTrainingValidities };
    } else if (error) return { error: JSON.stringify(error) };
  });
};

export const deleteTrainingValidity = input => {
  const mutation = require("../api/mutation/deleteTrainingValidity.gql");
  const variables = { id: input._id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    updateGetOrganizationsCache({
      trainingValidities: [input],
      isDelete: true,
    });

    if (data) return { data: data.deleteTrainingValidity };
    else if (error) return { error: JSON.stringify(error) };
  });
};
